export const toIntlLocale = (lang: string): string => {
  if (lang === 'cn') return 'zh';
  if (lang === 'ua') return 'uk';
  return lang;
};

export const toStorageLang = (locale: string): string => {
  if (locale === 'zh') return 'cn';
  if (locale === 'uk') return 'ua';
  return locale;
};

export const needsI18nLoad = (messages?: Record<string, unknown>): boolean =>
  !messages || Boolean(messages.initEmpty);
